<template>
  <b-card class="border-0" header-class="d-flex justify-content-between">
    <b-alert :show="errors.any()" variant="danger" class="px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>

    <label :for="`contactNumber${model.id}`">
      {{ $t('shared.contactNumber') }} :
      <required-symbol/>
    </label>

    <b-row class="align-items-center">
      <b-col md="auto">
        <b-form-group class="mb-md-0">
          <b-form-select :options="types" v-model="model.type"/>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group class="mb-md-0">
          <b-form-input
            :id="`contactNumber${model.id}`"
            dir="ltr"
            :placeholder="model.type === 'workPhoneNumber' || model.type === 'personalPhoneNumber' ? '0912xxxxxxx' : '021xxxxxxxx'"
            :name="$t('shared.contactNumber')"
            v-validate="'required|digits:11'"
            v-model="model.value"
          />
        </b-form-group>
      </b-col>

      <b-col md="auto">
        <b-btn
          class="p-0"
          variant="link"
          :title="$t('shared.remove')"
          v-b-tooltip
          @click="emitRemove"
        >
          <font-awesome-icon icon="trash-alt" class="text-danger align-middle"/>
        </b-btn>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'Item',
  props: {
    value: Object
  },
  data () {
    return {
      types: [
        { value: 'workPhoneNumber', text: this.$t('shared.fieldTypes.workPhoneNumber') },
        { value: 'workTelephoneNumber', text: this.$t('shared.fieldTypes.workTelephoneNumber') },
        { value: 'personalPhoneNumber', text: this.$t('shared.fieldTypes.personalPhoneNumber') },
        { value: 'personalTelephoneNumber', text: this.$t('shared.fieldTypes.personalTelephoneNumber') }
      ]
    }
  },
  computed: {
    model:{
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    emitRemove () {
      if (confirm(this.$t('shared.areYouSureToRemoveThisItem'))) {
        this.$emit('remove', this.model.id)
      }
    },
    validateAll () {
      return this.$validator.validateAll()
    }
  }
}
</script>